import http from "../http-common";

class DataService {

  registration_post(data) {
    return http.post("/register", data);
  }

  login_post(data) {
    return http.post("/login", data);
  }

  password_reset_post(data) {
    return http.post("/forgot-password", data);
  }

  password_reset_validate_post(data) {
    return http.post("/reset-password", data);
  }


  activate_account_post(data) {
    return http.post("/activation", data);
  }


  fetch_users_list(data,token) {
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };

    return http.post("/users_list", data,{headers: headers});
  }


  grant_role(data,token) {
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };

    return http.post("/grant_role", data,{headers: headers});
  }

  delete_user(data,token) {
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };

    return http.post("/delete_user", data,{headers: headers});
  }

  invite_user(data,token) {
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };

    return http.post("/invitation", data,{headers: headers});
  }

  delete_invite(data,token) {
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/delete_invitation", data,{headers: headers});
  }

  get_invite(data) {
    return http.post("/get-invitation", data);
  }


  user_products(data,token) {
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/user_products", data,{headers: headers});
  }

  user_products_per_division(data,token) {
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/user_products_per_division", data,{headers: headers});
  }

  user_divisions(data,token) {
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/user_divisions", data,{headers: headers});
  }

  assign_divisions(data,token) {
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/assign_divisions", data,{headers: headers});
  }


  get_company_name(data){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      //'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/get_company_name", data,{headers: headers});
  }


  get_user_details(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/get_user_details", data,{headers: headers});
  }



  change_password(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/change_password", data,{headers: headers});
  }



  update_user_details(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/update_user", data,{headers: headers});
  }

  change_invitation_role(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/change_invitation_role", data,{headers: headers});
  }


  products_search(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/searchProducts", data,{headers: headers});
  }

  create_recipient(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/create_recipient", data,{headers: headers});
  }


  update_recipient(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/update_recipient", data,{headers: headers});
  }


  delete_recipient(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/delete_recipient", data,{headers: headers});
  }

  get_recipients(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/get_recipients", data,{headers: headers});
  }

  get_company_divisions(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/get_company_divisions", data,{headers: headers});
  }

  get_invite_divisions(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/invite_divisions", data,{headers: headers});
  }

  change_user_language(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/change_language", data,{headers: headers});
  }

  get_countries(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.get("/get_country_list", data,{headers: headers});
  }


  get_regions(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/get_region_list", data,{headers: headers});
  }

  login_as_basic_user(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/login_as", data,{headers: headers});
  }


  submitting_the_checkout(data,token){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer '+token,
    };
    //
    return http.post("/submit_checkout", data,{headers: headers});
  }

  //

  //







}

export default new DataService();



// WEBPACK FOOTER //
// ./src/services/DataService.js